export enum WarehouseTab {
  SUMMARY = 0,
  ARTICLES,
  TICKETS_ENTRY_ARTICLES,
  TICKETS,
  TICKETS_COLLECTED,
  TICKETS_COMPLETE,
}
